import React, {useRef, useState, useEffect} from "react";
import styles from "./InfoItem.module.css";
import classNames from "classnames"
import {useDispatch, useSelector} from "react-redux";
import {Button, Checkbox, Col, message, Row, Switch} from 'antd'
import {setCurrentMenuKey} from "../AdminPageSlice";
import {setRechargeUserInfo} from "./SchoolInfoManagerSlice";

export default function InfoItem(props) {
    const dispatch = useDispatch();
    const [confirmInfo, setConfirmInfo] = useState({})
    const [messageApi, contextHolder] = message.useMessage();


    return <tr
        className={styles.tr1}
    >
        <td
            className={styles.td1}
        >{props.item.shengfen_name}
        </td>
        <td
            className={styles.td1}
        >{props.item.school_name}
        </td>
        <td
            className={styles.td1}
        >{props.item.school_type_name}
        </td>
        <td
            className={styles.td1}
        >{props.item.name}
        </td>
        <td
            className={styles.td1}
        >{props.item.type_name}
        </td>
        <td
            className={styles.td1}
        >{props.item.teacher_num}
        </td>
        {/* <td
            className={styles.td1}
        >{props.item.jifen}
        </td>
        <td
            className={styles.td1}
        >{props.item.type==2?(parseInt(props.item.jifen) - parseInt(props.item.chongzhi_shengyu_jifen))+'/'+parseInt(props.item.fenpei_zongfen):'---'}
        </td>
        <td
            className={styles.td1}
        >{props.item.type==2?props.item.chongzhi_shengyu_jifen+'/'+props.item.chongzhi_zongfen:'---'}
        </td> */}
        {/*<td*/}
        {/*    className={styles.td1}*/}
        {/*>{props.item.jifen}*/}
        {/*</td>*/}
        {/*<td*/}
        {/*    className={styles.td1}*/}
        {/*>{props.item.jifen}*/}
        {/*</td>*/}
        <td
            className={styles.td1}
        >
            <Switch
                checked={props.item.status == 1}
                onChange={(checked) => {
                    console.log(checked);
                    props.changeStatus(props.item, checked);
                }}
                checkedChildren="开"
                unCheckedChildren="关"
                // style={{ backgroundColor: user.status=='1' ? '#52c41a' : '#bfbfbf' }}
                style={{marginLeft: 10, marginRight: 10}}
            />

        </td>
        <td
            className={styles.td1}
        >{props.item.ctime}
        </td>
        <td
            className={styles.td1}
        >
            <Row style={{width: 220}}>
                <Col span={8}>
                    <Button
                        color="primary"
                        variant="link"
                        onClick={() => {
                            props.editMethod(props.item);
                        }}
                    >
                        编辑
                    </Button>
                </Col>
                <Col span={8}>
                    <Button
                        color="primary"
                        variant="link"
                        disabled={props.item.type != 2}
                        onClick={(e) => {
                            dispatch(setRechargeUserInfo(props.item));
                            dispatch(setCurrentMenuKey("11"))
                        }}
                    >
                        去充值
                    </Button>
                </Col>
                <Col span={8}>
                    <Button
                        color="primary"
                        variant="link"
                        onClick={(e) => {
                            props.deleteMethod(props.item);
                        }}
                    >
                        删除
                    </Button>
                </Col>
            </Row>
        </td>

        {contextHolder}
    </tr>
}
// export default PaymentInfoList;

